<template>
    <b-nav>
        <b-nav-item-dropdown
          id="my-nav-dropdown"
          toggle-class="nav-link-custom">
            <template slot="button-content">
                <i class="fa mr-2 fa-globe text-danger" font-scale="1"></i>
                <span>ENUM</span>
            </template>
            <b-dropdown-item to="/enum/tool">
                <i class="fa fa-plug text-green" font-scale="1"></i>
                    Enum Tool
              </b-dropdown-item>
        </b-nav-item-dropdown>
    </b-nav>
</template>

<script>
import initService from '../../../common/api-services/init-service';

export default {
  name: 'top-enum-group',
  data() {
    return {
      isPortalAdminStatus: false,
      isAdminStatus: false,
      groups: [],
      navPermissions: {
        "": {
          enable: false,
          role: ["PORTAL_ADMIN"]
        },
      }
    }
  },
  mounted() {
    this.isPortalAdminStatus = initService.getPortalAdminRole();
    this.isAdminStatus = initService.getAdministratorRole() || initService.getPortalAdminRole();
    this.groups = initService.getGroups();
    Object.keys(this.navPermissions).map(item => {
      this.groups.map(it => {
        if (this.navPermissions[item].role.includes(it)) this.navPermissions[item].enable = true;
      });
    });
  }
}
</script>